// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__w1n2u","bannerContent":"styles_bannerContent__YnJus","skipStepButton":"styles_skipStepButton__oAAve"};